module.exports = __webpack_public_path__ + "img/lotus-background.d6e6ac28.png";